import styled from "styled-components";

export const Summary = styled.h4`
  font-family: ${({ theme }) => theme.fonts.summary.family};
  font-size: ${({ theme }) => theme.fonts.summary.fontSize};
  line-height: ${({ theme }) => theme.fonts.summary.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.summary.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.summary.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
`;
